import React from "react";
import { Script } from "gatsby";
import { Helmet } from "react-helmet";

export const wrapPageElement = ({ element }) => {
    return (
        <>
            <Helmet>
                {/* Intellimize code */}
                <style>{`.anti-flicker, .anti-flicker * {visibility: hidden !important; opacity: 0 !important;}`}</style>
                <script>{`(function(e,t,p){var n=document.documentElement,s={p:[],r:[]},u={p:s.p,r:s.r,push:function(e){s.p.push(e)},ready:function(e){s.r.push(e)}};e.intellimize=u,n.className+=" "+p,setTimeout(function(){n.className=n.className.replace(RegExp(" ?"+p),"")},t)})(window, 4000, 'anti-flicker')`}</script>
                <link rel="preload" href="https://cdn.intellimize.co/snippet/117890808.js" as="script" />
                <script src="https://cdn.intellimize.co/snippet/117890808.js" async onerror="document.documentElement.className = document.documentElement.className.replace(RegExp(' ?anti-flicker'), '');"></script>
                <link rel="preconnect" href="https://api.intellimize.co" crossorigin />
                <link rel="preconnect" href="https://117890808.intellimizeio.com" />
                <link rel="preconnect" href="https://log.intellimize.co" crossorigin />
                {/* Intellimize code ends */}
                <script src="https://ug-webapp-public-production.s3.amazonaws.com/api/js/wv-ug-KMEk4YZ9FQykXoQC.js"></script>
                <script src="https://assets.adoberesources.net/loader.js?orgId=D5AC14A26113EAB70A495C3C%40AdobeOrg&instanceId=hostanalytics2&env=prod&geo=va7"></script>
            </Helmet>
            {element}
            {/* <Script src="/drift.js" /> */}

        </>
    )
}

export const onRouteUpdate = () => {
    if (typeof window !== "undefined" && window.intellimize) {
        const intellimize = window.intellimize;

        intellimize.ready(function () {
            intellimize.activate();
            console.log('Intellimize activated as per the route change' + intellimize.activate());
        });
    }
    // console.log("Shared: Route changed from", prevLocation?.pathname, "to", location.pathname);
};